// extracted by mini-css-extract-plugin
export default {"container":"_error_container__X7by-"};